/**
 * Lectures Number Cell - Frontend
 * @description Cell component for displaying lecture number in LecturesTable
 */

import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { LecturesTableData } from '@/types/operational-ui.types';

interface LecturesNumberCellProps {
  info: CellContext<LecturesTableData, number>;
}

export const LecturesNumberCell: React.FC<LecturesNumberCellProps> = ({ info }) => {
  const lectureNumber = info.getValue();

  return <div className="font-medium text-center text-gray-900">#{lectureNumber}</div>;
};
